// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.navbar-item > span[data-v-2505659d] {\n  margin-left: 5px;\n}\n.navbar-item[data-v-2505659d] {\n  cursor: pointer;\n  margin-right: 20px;\n}\n.flags-size[data-v-2505659d] {\n  height: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
